<template>
  <svg class="svg-icon"  aria-hidden="true" @click="handleClick">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    // 图标类型
    type: {
      type: String,
      required: true,
    },
    handle: {
      type: Function,
      default: () => {},
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.type}`;
    },
  },
  methods: {
    handleClick(e) {
      this.$emit("click", e);
      if(this.handle) {
        this.handle()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: currentColor;
}
</style>
